import "@/App.css";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { initAds } from "@/utils/gtag";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Trucks from "@/pages/Trucks";
import Booking from "@/pages/Booking";
import CompleteJob from "@/pages/CompleteJob";
import ThankYou from "@/pages/ThankYou";
import InventoryCalculator from "@/pages/InventoryCalculator";
import InvoicePage from "@/pages/InvoicePage";
import PayInvoice from "@/pages/PayInvoice";
import BookingFee from "@/pages/BookingFee";
import LegalPage from "@/pages/Legal";
import ServicePage from "@/pages/ServicePage";
import SuburbPage from "@/pages/SuburbPage";
import PricingPage from "@/pages/PricingPage";
import FaqPage from "@/pages/FaqPage";
import ContactPage from "@/pages/ContactPage";
import Mover from "@/pages/Mover";
import StaffLogin from "@/pages/StaffLogin";
import { MobileCallBar } from "@/components/MobileCallBar";
import { BrandBackdrop } from "@/components/BrandBackdrop";

function App() {
  useEffect(() => {
    initAds();
  }, []);

  return (
    <HelmetProvider>
    <div className="App text-slate-900 min-h-screen pb-14 sm:pb-0">
      <BrandBackdrop />
      <div className="noise-overlay" />
      <ReactLenis root options={{ lerp: 0.08, duration: 1.4 }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/trucks" element={<Trucks />} />
            <Route path="/inventory-calculator" element={<InventoryCalculator />} />
            <Route path="/invoice" element={<InvoicePage />} />
            <Route path="/pay-invoice" element={<PayInvoice />} />
            <Route path="/booking" element={<Booking mode="quote" />} />
            <Route path="/book-online" element={<Booking mode="booking" />} />
            <Route path="/complete-job" element={<CompleteJob />} />
            <Route path="/thanks" element={<ThankYou />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/booking-fee" element={<BookingFee />} />
            <Route path="/removalists-melbourne-near-me" element={<Home />} />
            <Route path="/removalists-melbourne-near-me/thank-you" element={<ThankYou />} />
            <Route path="/privacy" element={<LegalPage page="privacy" />} />
            <Route path="/terms" element={<LegalPage page="terms" />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/removalists/:slug" element={<SuburbPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/signoff" element={<CompleteJob />} />
            <Route path="/mover" element={<Mover />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/app" element={<StaffLogin />} />
            <Route path="/staff" element={<StaffLogin />} />
            <Route path="/login" element={<StaffLogin />} />
          </Routes>
          <MobileCallBar />
        </BrowserRouter>
      </ReactLenis>
      <Toaster theme="dark" position="bottom-right" />
    </div>
    </HelmetProvider>
  );
}

export default App;
